// material-ui
import React from 'react';
import { Box, useMediaQuery, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

// project import
import Profile from './Profile';
import FeedbackDialog from './FeedbackDialog';
// import Notification from './Notification';
import MobileSection from './MobileSection';
import LanguageSwitcher from './LanguageSwitcher';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [feedbackOpen, setFeedbackOpen] = React.useState(false);
    const { t } = useTranslation();

    return (
        <>
            <Box sx={{ width: '100%', ml: 1 }} />
            {/* <Notification /> */}
            {!matchesXs && (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setFeedbackOpen(true)}
                    sx={{ mr: 1, minWidth: 'auto', whiteSpace: 'nowrap' }}
                >
                    {t('app.feedback')}
                </Button>
            )}
            {!matchesXs && (
                <Box sx={{ mr: 1 }}>
                    <LanguageSwitcher />
                </Box>
            )}
            {!matchesXs && <Profile />}
            {matchesXs && <MobileSection />}
            <FeedbackDialog open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
        </>
    );
};

export default HeaderContent;
